// SectionRepository.js
class SectionRepository {
    constructor() {
        // Base URL for your API - change this to your deployed server URL
        //this.apiUrl = 'http://147.93.95.186:5000/api'; // Default for local development
        this.apiUrl = 'https://server.unitesainteveronique.com/api'; // Default for local development
    }

    // Set the API URL (useful for different environments)
    setApiUrl(url) {
        this.apiUrl = url;
    }

    async getSectionById(id) {
        try {
            const response = await fetch(`${this.apiUrl}/sections/${id}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch section: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching section by ID:', error);
            throw error;
        }
    }

    async updateSection(id, updatedSection) {
        // Validate input
        if (!id) {
            throw new Error('Section ID is required');
        }

        // Process images with fallback to existing values
        const formData = new FormData();

        // Add text fields
        formData.append('Nom', updatedSection.Nom);
        formData.append('description', updatedSection.description);
        formData.append('mail', updatedSection.mail);
        formData.append('compte', updatedSection.compte);
        formData.append('lien_drive', updatedSection.lien_drive);

        // Add file fields
        if (updatedSection.background instanceof File) {
            formData.append('background', updatedSection.background);
        } else if (updatedSection.background) {
            formData.append('backgroundUrl', updatedSection.background);
        }

        if (updatedSection.first_picture instanceof File) {
            formData.append('first_picture', updatedSection.first_picture);
        } else if (updatedSection.first_picture) {
            formData.append('first_pictureUrl', updatedSection.first_picture);
        }

        if (updatedSection.second_picture instanceof File) {
            formData.append('second_picture', updatedSection.second_picture);
        } else if (updatedSection.second_picture) {
            formData.append('second_pictureUrl', updatedSection.second_picture);
        }

        if (updatedSection.uniforme instanceof File) {
            formData.append('uniforme', updatedSection.uniforme);
        } else if (updatedSection.uniforme) {
            formData.append('uniformeUrl', updatedSection.uniforme);
        }

        try {
            const response = await fetch(`${this.apiUrl}/sections/${id}`, {
                method: 'PUT',
                body: formData,
                // Don't set Content-Type header when using FormData
                // the browser will set it automatically with the correct boundary
            });

            if (!response.ok) {
                throw new Error(`Failed to update section: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error updating section:', error);
            throw error;
        }
    }

    async getAllBackgroundImage() {
        try {
            const response = await fetch(`${this.apiUrl}/section/backgrounds`);
            if (!response.ok) {
                throw new Error(`Failed to fetch backgrounds OUI : ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching background images:', error);
            throw error;
        }
    }

    async getAllDescImage() {
        try {
            const response = await fetch(`${this.apiUrl}/section/descriptions`);
            if (!response.ok) {
                throw new Error(`Failed to fetch description images: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching description images:', error);
            throw error;
        }
    }

    async getAllSections() {
        try {
            const response = await fetch(`${this.apiUrl}/sections`);
            if (!response.ok) {
                throw new Error(`Failed to fetch sections: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching all sections:', error);
            throw error;
        }
    }
}

export default SectionRepository;